import { Box } from "@mui/material";
import React from "react";

function Container({ children }) {
  return <Box sx={{ p: { xs: 2, md: 5 } }}>{children}</Box>;
}

export default Container;
